import { Layout } from 'antd'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import Header from 'src/components/layout/Header'
import { LoginPage } from 'src/pages/Login'
import { SignUpPage } from 'src/pages/SignUp'
import useAuth from 'src/store/hooks/authentication'
import Footer from 'src/components/layout/Footer'

const { Content } = Layout

function PrivateLayout({ children }) {
  const { actions, data } = useAuth()

  useEffect(() => {
    actions.getConfig()
    if (isEmpty(data.account)) {
      actions.getAccountInfo()
    }

    // Lắng nghe sự kiện "OpenModalLogin"
    const handleOpenSignIn = () => {
      setOpenSignIn(true) // Mở modal đăng nhập
    }

    window.addEventListener('OpenModalLogin', handleOpenSignIn)

    // Cleanup khi component bị unmount
    return () => {
      window.removeEventListener('OpenModalLogin', handleOpenSignIn)
    }
  }, [])

  const [openRegister, setOpenRegister] = useState(false)
  const [openSignIn, setOpenSignIn] = useState(false)

  return (
    <>
      <Header
        handleClickSignIn={() => setOpenSignIn(true)}
        handleClickRegister={() => setOpenRegister(true)}
      />
      <Layout className="bg-transparent pt-6">
        <Content>{children}</Content>
        <LoginPage
          setOpenSignUp={setOpenRegister}
          open={openSignIn}
          setOpenSignIn={setOpenSignIn}
        />
        <SignUpPage
          open={openRegister}
          setOpenSignUp={setOpenRegister}
          setOpenSignIn={setOpenSignIn}
        />
      </Layout>
      <Footer />
    </>
  )
}

export default PrivateLayout
